'use client';

import { useEffect, useRef } from 'react';
import { motion, useInView, useSpring, useTransform } from 'framer-motion';

function formatInt(num: number, prec = 1) {
  const mult = Math.pow(10, prec);
  return Math.floor(num / mult) * mult;
}

export function Customers({ userCount }: { userCount: number }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const motionValue = useSpring(0, { damping: 50, stiffness: 100 });
  const rounded = useTransform(motionValue, (latest) =>
    formatInt(Math.round(latest)),
  );

  useEffect(() => {
    if (isInView) {
      motionValue.set(userCount);
    }
  }, [motionValue, isInView, userCount]);

  return (
    <p className="text-sm font-medium text-gray-500" ref={ref}>
      Loved by{' '}
      <span className="relative inline-block tabular-nums">
        <span className="invisible">{formatInt(userCount)}</span>
        <motion.span className="absolute inset-0">{rounded}</motion.span>
      </span>
      + happy customers
    </p>
  );
}
